<template>
  <div>
    <div class="grid bg-white">
      <div class="grid-title">
        <h4>Station Listings</h4>
      </div>
      <div class="grid-body">
        <!-- select box of area -->
        <div class="row">
          <div class="col-md-4">
            <v-select
              placeholder="SELECT AREA"
              v-model="shirtOrderStatusId"
              :options="areas"
              @input="changeArea"
              :reduce="(areas) => areas.id"
            />
          </div>
          <div class="col-md-8 text-right">
            <button
              v-if="shirtOrderStatusId != null"
              class="btn btn-primary"
              @click="newStation()"
            >
              <i class="fa fa-plus-circle" aria-hidden="true"></i> Add New
              Station in This Area
            </button>
          </div>
        </div>
        <br />
        <!-- end select box of area -->

        <!-- error -->
        <div class="alert alert-danger" v-if="error">
          <strong>{{ error }}</strong>
        </div>

        <!-- station list table -->
        <table class="table table-bordered">
          <thead>
            <tr>
              <th class="station-name">Station Name</th>
              <th>Type</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(station, index) in stations" :key="station.id">
              <td class="text-capitalize">{{ station.name }}</td>
              <td class="text-capitalize">{{ station.type }}</td>
              <td>
                <button
                  class="btn btn-primary btn-sm"
                  @click="editStation(index)"
                >
                  Edit
                </button>
                <button
                  class="btn btn-danger btn-sm"
                  @click="deleteStation(index)"
                >
                  Delete
                </button>
              </td>
            </tr>
          </tbody>
        </table>
        <!-- end station list table -->

        <!-- model to create -->
        <div
          class="modal fade"
          id="modal-station"
          tabindex="-1"
          role="dialog"
          aria-labelledby="modelTitleId"
          aria-hidden="true"
        >
          <div class="modal-dialog" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title" v-if="editId == null">New Station</h5>
                <h5 class="modal-title" v-else>Update Station</h5>
                <button
                  type="button"
                  class="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body">
                <div class="row">
                  <!-- station name -->
                  <div class="col-md-12">
                    <div class="form-group">
                      <label for="">Station Name</label>
                      <input
                        type="text"
                        class="form-control"
                        v-model="stationName.value"
                        placeholder="Name"
                      />
                      <small
                        class="form-text text-danger"
                        v-if="stationName.error"
                        >{{ stationName.error }}</small
                      >
                    </div>
                  </div>
                  <!-- station type -->
                  <div class="col-md-12">
                    <div class="form-group">
                      <label for="">Station Type</label>
                      <input
                        type="text"
                        class="form-control"
                        v-model="stationType.value"
                        placeholder="Type"
                      />
                      <small
                        class="form-text text-danger"
                        v-if="stationType.error"
                        >{{ stationType.error }}</small
                      >
                    </div>
                  </div>
                </div>
              </div>
              <div class="modal-footer">
                <button
                  type="button"
                  class="btn btn-secondary"
                  data-dismiss="modal"
                >
                  Close
                </button>
                <button
                  type="button"
                  class="btn btn-primary"
                  v-if="editId == null"
                  @click="saveStation()"
                >
                  Save
                </button>
                <button
                  type="button"
                  class="btn btn-primary"
                  v-else
                  @click="saveStation()"
                >
                  Update
                </button>
              </div>
            </div>
          </div>
        </div>
        <!-- end model to create -->
      </div>
    </div>
  </div>
</template>

<script>
import AreaStatusMatching from "./tools/AreaStatusMatching.json";
import vSelect from "vue-select";
import _ from "lodash";

export default {
  components: {
    vSelect,
  },
  data() {
    return {
      areas: [],
      shirtOrderStatusId: null,
      stations: [],
      stationName: { value: null, error: null },
      stationType: { value: null, error: null },
      error: null,
      editId: null,
    };
  },
  mounted() {
    this.getAreas();
  },
  methods: {
    getAreas() {
      let data = AreaStatusMatching.en;
      data.forEach((val) => {
        this.areas.push(val);
      });
    },
    async getStations() {
      let res = await axios.get(
        "performance_tracking/station/listings/" + this.shirtOrderStatusId
      );
      this.stations = res.data;
    },
    changeArea() {
      if (this.shirtOrderStatusId == null) {
        this.stations = [];
      } else {
        this.getStations();
      }
    },
    newStation() {
      if (this.shirtOrderStatusId == null) {
        this.error = "Please Select the Area First";
      } else {
        this.error = null;
        this.editId = null;
        this.stationName.value = null;
        this.stationType.value = null;
        show_modal("#modal-station");
      }
    },
    editStation(index) {
      let data = this.stations[index];
      this.editId = data.id;
      this.stationName.value = data.name;
      this.stationType.value = data.type;
      show_modal("#modal-station");
    },
    async deleteStation(index) {
      let res = await Swal.fire({
        title: "Are you sure ?",
        icon: "",
        showCancelButton: true,
        confirmButtonColor: "#0aa699",
        cancelButtonColor: "#d33",
        confirmButtonText: "YES",
      });
      if (res.value) {
        let id = this.stations[index].id;
        let res = await axios.delete(
          "/performance_tracking/station/delete/" + id
        );
        this.stations.splice(index, 1);
      }
    },
    async saveStation() {
      if (this.stationName.value == null || this.stationName.value == "") {
        this.stationName.error = "Required Station Name";
      } else {
        this.stationName.error = null;
        let data = {
          name: this.stationName.value,
          type: this.stationType.value,
          shirt_order_status_id: this.shirtOrderStatusId,
        };
        try {
          if (this.editId == null) {
            let res = await axios.post(
              "/performance_tracking/station/create",
              data
            );
            this.stations.unshift(res.data.data);
          } else {
            let res = await axios.put(
              "/performance_tracking/station/update/" + this.editId,
              data
            );
            let index = _.findIndex(this.stations, { id: this.editId });
            this.stations[index].name = res.data.data.name;
            this.stations[index].type = res.data.data.type;
          }
          hide_modal("#modal-station");
        } catch (err) {
          hide_modal("#modal-station");
          this.error = "Same Station Already Exist";
        }
      }
    },
  },
};
</script>

<style scoped>
.fabric-category {
  width: 200px;
}
.fabric-number {
  width: 300px;
}
.text-capitalize {
  text-transform: capitalize;
}
.station-name {
  width: 300px;
}
.modal-header .close {
  margin-top: -21px !important;
}
</style>
